<template>
  <v-container>
    <h4>Personal Information</h4>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <v-img
          lazy-src="https://picsum.photos/id/11/10/6"
          :src="image_src"
          aspect-ratio="1"
          max-width="300"
          max-height="300"
          :eager="true"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Firstname:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ personal_information.firstname || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Display name/ Nickname:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ personal_information.display_name || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Gender:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ personal_information.gender || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Birthday:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ personal_information.birthdate || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Weight:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ personal_information.weight || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Height:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ personal_information.height || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Marriage status:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ personal_information.marriage_status || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Nationality:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ personal_information.nationality || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Religion:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ personal_information.religion || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Personal ID:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ personal_information.personal_id || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Passport ID:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ personal_information.passport_id || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Driving license:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p
          v-if="personal_information.driving_license"
        >
          Yes
        </p>
        <p
          v-else
        >
          -
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Motorbike driving license:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        
        <p
          v-if="personal_information.motorbike_driving_license"
        >
          Yes
        </p>
        <p
          v-else
        >
          -
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Vaccine:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        
        <p
          v-if="personal_information.vaccine"
        >
          Yes
        </p>
        <p
          v-else
        >
          -
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Work permit:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        
        <p
          v-if="personal_information.work_permit"
        >
          Yes
        </p>
        <p
          v-else
        >
          -
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
        v-if="personal_information.work_permit"
      >
        <p>Work permit expiration date:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
        v-if="personal_information.work_permit"
      >
        
        <p>{{ personal_information.work_permit_expiration_date || '-' }}</p>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'PersonalInformation',
  components: { },
  props: ['personal_information', 'image_src'],
  data: () => ({ }),
  methods: { }
}
</script>

<style scoped>
</style>